// Common filter expressions for clusters
export const FILTER_CLUSTERS = ['has', 'point_count'];
export const FILTER_NOT_CLUSTERS = ['!', FILTER_CLUSTERS];

// Layer IDs for consistent reference
export const RESTAURANT_LAYER_ID = 'restaurant';
export const CLUSTER_LAYER_ID = 'clusters';
